document.addEventListener('DOMContentLoaded', function() {
        // 1. Seleziona tutti i form con la classe "form-iub"
        const iubendaForms = document.querySelectorAll('.form-iub');

        // 2. Applica la logica a ciascun form trovato
        iubendaForms.forEach(form => {
            form.addEventListener('submit', function(event) {
                event.preventDefault();

                const currentForm = event.currentTarget;
                const emailInput = currentForm.querySelector('input[data-cons-subject="email"]');

                 // 5. Controlla che lo script di Iubenda sia presente sulla pagina
                if (typeof _iub === 'undefined' || typeof _iub.cons_instructions === 'undefined') {
                    console.error("Script Iubenda (_iub) non trovato. Impossibile registrare il consenso.");
                    // In questo caso, potresti voler inviare il form normalmente
                    // currentForm.submit(); 
                    return;
                }

                if (!currentForm.checkValidity()) {
                    console.warn('Il form non è valido. Uno o più campi obbligatori non sono compilati.');
                    
                    // Mostra i messaggi di errore del browser associati ai campi non validi.
                    // Questa è la parte che avvisa visivamente l'utente.
                    currentForm.reportValidity();
                    
                    return; // Interrompe l'esecuzione
                }else{
                    console.log("Invio consenso a Iubenda per il form:", currentForm.id || 'Nessun ID');
                    
                    _iub.cons_instructions.push([
                        "submit",
                        {
                            form: {
                                selector: currentForm
                            },
                            consent: {
                                // Specifica per quali documenti legali si sta dando il consenso
                                legal_notices: [
                                    { identifier: "privacy_policy" },
                                    { identifier: "cookie_policy" },
                                    { identifier: "term" },
                                ],
                            }
                        },
                        {
                            // Al successo, puoi eseguire azioni aggiuntive come un redirect
                            success: function(response) {
                                console.log("✅ Consenso Iubenda registrato con successo:", response);
                                
                                // OPZIONALE: Reindirizza a una pagina di ringraziamento
                                // window.location.href = '/pagina-di-ringraziamento';

                                // OPZIONALE: Resetta i campi del form
                                currentForm.reset();
                            },
                            // In caso di errore
                            error: function(response) {
                                console.error("❌ Errore nella registrazione del consenso Iubenda:", response);
                                alert("Si è verificato un errore durante la registrazione del consenso. Riprova.");
                            },
                        },
                    ]);
                }

            });
        });
    });